export enum FolderEntites {
    Channels,
    ChannelGroups,
    Backgrounds,
    Templates,
    Solutions,
    Players,
    Files,
    DirectFiles,
    Sessions,
    StockFiles,
    SystemFiles
}

export interface Folder {
    id: string;
    name: string;
    path: string;
    claim: string;
    isOpen: boolean;
    isSelected: boolean;
    editMode: boolean;
    activateDelete: boolean;
    dropNotAllowed: boolean;
    parentFolderId: string;
    children?: Folder[];
}

export interface RootFolder {
    id: string;
    name: string;
}

export interface FolderDtoIn {
    id: string;
    name: string;
    parentFolderId: string;
    folderEntity: FolderEntites;
}

export interface MoveFolderDtoIn {
    id: string;
    targetFolderId: string;
}

export interface MoveEntityDtoIn {
    entityId: string;
    targetFolderId: string;
    folderEntity: FolderEntites;
}

export interface FolderOption {
    id: string;
    path: string;
}
